import { render, staticRenderFns } from "./one-column.vue?vue&type=template&id=41364fe3&scoped=true"
import script from "./one-column.vue?vue&type=script&lang=js"
export * from "./one-column.vue?vue&type=script&lang=js"
import style0 from "./one-column.vue?vue&type=style&index=0&id=41364fe3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41364fe3",
  null
  
)

export default component.exports